import * as actions from '../../redux/actions';

import CommonService from '../../../../services/commonService';
import KuposInput from '../../KuposInput';
import KuposSelectBox from '../../KuposSelectBox';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const CuponeraBookingInputs = ({
  idCardTypes = [],
  countries = [],
  passengerDetails,
  onChange,
  t,
  onInputBlur,
  seatsTitle,
}) => {
  console.log({ idCardTypes });
  console.log({ countries });
  console.log({ passengerDetails });

  return (
    <div className="pb-payment-details-booking-input kupos-card">
      <div style={styles.info_title} className="bold-text">
        {seatsTitle}
      </div>

      <div style={styles.passenger_input_wrapper} className="bold-text font10">
        <span className="nationality-input">{t('PASSENGER_DETAILS.NATIONALITY')}</span>
        <span className="doc-input">{t('PASSENGER_DETAILS.DOCUMENT')}</span>
        <span className="rut-input">{t('PASSENGER_DETAILS.DOC_NUM_DEGREE')}</span>
        <span className="name-input">{t('PASSENGER_DETAILS.NAME')}</span>
        <span className="last_name-input">{t('PASSENGER_DETAILS.SURNAME')}</span>
      </div>
      <div style={styles.passenger_input_wrapper} className="font10 coup-select">
        <span className="nationality-input" style={styles.country_dd}>
          {/* {idCardTypes && idCardTypes.length ? ( */}
          <KuposSelectBox
            options={countries}
            selectedOption={passengerDetails ? passengerDetails.country : {}}
            onChange={val => onChange(val, 'country')}
            height={40}
            showAll={true}
            disabled={true}
            t={t}
            marginTop={0.1}
            // key={passenger && passenger.nationality && passenger.nationality.value}
            // disabled={disable}
          />
          {/* ) : (
            <div></div>
          )} */}
        </span>
        <span className="doc-input">
          {/* {idCardTypes && idCardTypes.length ? ( */}
          {passengerDetails && passengerDetails.idCardType ? (
            <KuposSelectBox
              options={idCardTypes}
              selectedOption={passengerDetails ? passengerDetails.idCardType : {}}
              onChange={val => onChange(val, 'idCardType')}
              height={40}
              showAll={true}
              disabled={true}
              t={t}
              marginTop={0.1}
              // key={props.inputs && props.inputs.idCardType && props.inputs.idCardType.value}
              // disabled={disable}
            />
          ) : null}
          {/* ) : (
            <div></div>
          )} */}
        </span>
        <span className="rut-input">
          <KuposInput
            className="kupos-border"
            type="text"
            // placeholder= {t('PASSENGER_DETAILS.DOC_NUMBER')}
            value={passengerDetails ? passengerDetails.idCardNumber : ''}
            onChange={text => onChange(text, 'idCardNumber')}
            onBlur={text => onInputBlur(text, 'idCardNumber')}
            error={passengerDetails.idCardNumberError ? true : false}
            errorMessage={
              passengerDetails.idCardNumberError ? t(passengerDetails.idCardNumberError) : ''
            }
            disabled={true}
          />
        </span>
        <span className="name-input">
          <KuposInput
            className="kupos-border"
            type="text"
            // placeholder={t('PASSENGER_DETAILS.NAME')}
            value={passengerDetails ? passengerDetails.name : ''}
            onChange={text => onChange(text, 'name')}
            onBlur={text => onInputBlur(text, 'name')}
            error={passengerDetails.nameError ? true : false}
            errorMessage={passengerDetails.nameError ? t(passengerDetails.nameError) : ''}
            disabled={true}
          />
        </span>
        <span className="name-input">
          <KuposInput
            className="kupos-border"
            type="text"
            // placeholder={t('PASSENGER_DETAILS.SURNAME')}
            value={passengerDetails ? passengerDetails.lastName : ''}
            onChange={text => onChange(text, 'lastName')}
            onBlur={text => onInputBlur(text, 'lastName')}
            error={passengerDetails.lastNameError ? true : false}
            errorMessage={passengerDetails.lastNameError ? t(passengerDetails.lastNameError) : ''}
            disabled={true}
          />
        </span>
      </div>

      <div style={styles.contact_section}>
        <div style={styles.passenger_contact_wrapper} className=" bold-text font10">
          <span className="emailinput">{t('PASSENGER_DETAILS.EMAIL_ID')}</span>
          <span className="email-input">{t('PASSENGER_DETAILS.EMAIL_CONFIRMATION')}</span>
          <span className="phone-input">{t('PASSENGER_DETAILS.PHONE_NUMBER')}</span>
        </div>
        <div style={styles.passenger_contact_wrapper} className="font10">
          <span className="email-input">
            <KuposInput
              className="kupos-border"
              type="email"
              value={passengerDetails ? passengerDetails.email : ''}
              onChange={text => onChange(text, 'email')}
              onBlur={text => onInputBlur(text, 'email')}
              error={passengerDetails.emailError ? true : false}
              errorMessage={passengerDetails.emailError ? t(passengerDetails.emailError) : ''}
              disabled={true}
            />
          </span>
          <span className="email-input">
            <KuposInput
              className="kupos-border confirm-email"
              type="email"
              value={passengerDetails ? passengerDetails.confirmEmail : ''}
              onChange={text => onChange(text, 'confirmEmail')}
              onBlur={text => onInputBlur(text, 'confirmEmail')}
              error={passengerDetails.confirmEmailError ? true : false}
              disabled={true}
              errorMessage={
                passengerDetails.confirmEmailError ? t(passengerDetails.confirmEmailError) : ''
              }
            />
          </span>
          <span className="phone-input">
            <KuposInput
              placeholder="9XXXXXXXX"
              className="kupos-border"
              type="tel"
              value={passengerDetails ? passengerDetails.mobile : ''}
              onChange={text => onChange(text, 'mobile')}
              onBlur={text => onInputBlur(text, 'mobile')}
              error={passengerDetails.mobileError ? true : false}
              errorMessage={passengerDetails.mobileError ? t(passengerDetails.mobileError) : ''}
              disabled={true}
            />
          </span>
        </div>
      </div>
    </div>
  );
};

const styles = {
  info_title: {
    marginBottom: 20,
  },
  passenger_input_wrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr 2fr 2fr 2fr',
    gap: 10,
    marginBottom: 6,
  },
  country_dd: {
    minWidth: 94,
  },
  contact_section: {
    marginTop: 22,
  },
  passenger_contact_wrapper: {
    display: 'grid',
    gridTemplateColumns: '2fr 2fr 1.3fr',
    gap: 10,
  },
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbPaymentDetails: state.pbPaymentDetails,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CuponeraBookingInputs);



// WEBPACK FOOTER //
// ./src/features/common/Cuponera/BookingInputs/CuponeraBookingInputs.js